import React from 'react'
import { Typography, Input, Row, Col, Form, Collapse, Space, Button } from 'antd'
import PropTypes from 'prop-types'

import DownArrow from '../PositionArrows/DownArrow'
import UpArrow from '../PositionArrows/UpArrow'
import styles from './PriceCards.module.css'

const { Title } = Typography
const { TextArea } = Input
const { Panel } = Collapse

const PriceCards = ({ priceCard, setPriceCards }) => {
  const deletePriceCard = (event, index) => {
    event.stopPropagation()
    const clonedPriceCard = [...priceCard]
    if (index !== -1) {
      clonedPriceCard.splice(index, 1)
    }
    setPriceCards(clonedPriceCard)
  }

  const handleHeaderChange = ({ target }, index) => {
    const clonedPriceCard = [...priceCard]
    clonedPriceCard[index] = {
      ...clonedPriceCard[index],
      title: target.value
    }
    setPriceCards([...clonedPriceCard])
  }
  const handleSubtitleChange = ({ target }, index) => {
    const clonedPriceCard = [...priceCard]
    clonedPriceCard[index] = {
      ...clonedPriceCard[index],
      sub_title: target.value
    }
    setPriceCards([...clonedPriceCard])
  }

  const handleDisclaimerChange = ({ target }, index) => {
    const clonedPriceCard = [...priceCard]
    clonedPriceCard[index] = {
      ...clonedPriceCard[index],
      disclaimer: target.value
    }
    setPriceCards([...clonedPriceCard])
  }

  const handlePriceFormIdUpdate = ({ target }, index) => {
    const clonedPriceCard = [...priceCard]
    clonedPriceCard[index] = {
      ...clonedPriceCard[index],
      formstack_id: target.value
    }
    setPriceCards([...clonedPriceCard])
  }

  const handlePriceUpdate = ({ target }, index) => {
    const clonedPriceCard = [...priceCard]
    clonedPriceCard[index] = {
      ...clonedPriceCard[index],
      price: target.value
    }
    setPriceCards([...clonedPriceCard])
  }

  const handleCTANameChange = (event, index) => {
    const clonedPriceCard = [...priceCard]
    clonedPriceCard[index] = {
      ...clonedPriceCard[index],
      cta: { ...clonedPriceCard[index].cta, name: event.target.value }
    }
    setPriceCards([...clonedPriceCard])
  }
  const handleCTAUrlChange = (event, index) => {
    const clonedPriceCard = [...priceCard]
    clonedPriceCard[index] = {
      ...clonedPriceCard[index],
      cta: { ...clonedPriceCard[index].cta, url: event.target.value }
    }
    setPriceCards([...clonedPriceCard])
  }

  const handleMoveUp = (event, id) => {
    event.stopPropagation()
    const clonedPriceCard = [...priceCard]
    if (id > 0) {
      const el = clonedPriceCard[id]
      clonedPriceCard[id] = clonedPriceCard[id - 1]
      clonedPriceCard[id - 1] = el
      setPriceCards([...clonedPriceCard])
    }
  }

  const handleMoveDown = (event, id) => {
    event.stopPropagation()
    const clonedPriceCard = [...priceCard]
    if (id !== -1 && id < clonedPriceCard.length - 1) {
      const el = clonedPriceCard[id]
      clonedPriceCard[id] = clonedPriceCard[id + 1]
      clonedPriceCard[id + 1] = el
      setPriceCards([...clonedPriceCard])
    }
  }

  return (
    <div className={styles['content-card-container']}>
      <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right' style={{ width: '100%' }}>
        {priceCard?.map((card, rowIndex) => (<Panel key={rowIndex}
          extra={<Row gutter={2}><Space>
            <Col align="left" span={4}>
              <Row gutter={[10]} style={{ width: '60px' }}>
                {rowIndex !== 0 && <Col align='right' data-testid="up-arrow" onClick={(event) => handleMoveUp(event, rowIndex)} span={12}>
                  <UpArrow />
                </Col>
                }
                {priceCard?.length - rowIndex !== 1
                  ? <Col align="left" data-testid="down-arrow" onClick={(event) => handleMoveDown(event, rowIndex)} span={12}>
                    <DownArrow />
                  </Col>
                  : <Col span={3} />}
              </Row>
            </Col>
            <Button danger onClick={(event) => deletePriceCard(event, rowIndex)} style={{ backgroundColor: '#DA0D50', color: '#fff' }}>Delete</Button>
          </Space>
          </Row>
          }
          header={<span style={{ fontSize: 20 }}>{card?.title}</span>}>
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Title*</Title></Col>
          </Row>
          <Row>
            <TextArea
              autoSize={{ minRows: 2 }}
              onChange={(e) => handleHeaderChange(e, rowIndex)}
              style={{ width: '100%' }}
              value={card?.title}
            />
          </Row>
          <br />
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Sub Title</Title></Col>
          </Row>
          <Row>
            <TextArea
              autoSize={{ minRows: 1 }}
              onChange={(e) => handleSubtitleChange(e, rowIndex)}
              style={{ width: '100%' }}
              value={card?.sub_title}
            />
          </Row>
          <br />
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Disclaimer</Title></Col>
          </Row>
          <Row>
            <TextArea
              autoSize={{ minRows: 2 }}
              onChange={(e) => handleDisclaimerChange(e, rowIndex)}
              style={{ width: '100%' }}
              value={card?.disclaimer}
            />
          </Row>
          <br />
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Formstack Id</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item><Input onChange={(event) => handlePriceFormIdUpdate(event, rowIndex)} value={card?.formstack_id}/></Form.Item>
            </Col>
          </Row>
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Price</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item><Input onChange={(event) => handlePriceUpdate(event, rowIndex)} value={card?.price}/></Form.Item>
            </Col>
          </Row>
          <br />
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Call-to-Action Label*</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item><Input onChange={(event) => handleCTANameChange(event, rowIndex)} value={card.cta?.name}/></Form.Item>
            </Col>
          </Row>
          <br />
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Call-to-Action URL*</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item><Input onChange={(event) => handleCTAUrlChange(event, rowIndex)} value={card.cta?.url}/></Form.Item>
            </Col>
          </Row>
        </Panel>))
        }
      </Collapse>
    </div>
  )
}

PriceCards.propTypes = {
  deletePriceCard: PropTypes.func,
  priceCard: PropTypes.array,
  setPriceCards: PropTypes.func
}

export default PriceCards
